import {
    endOfMonth,
    endOfQuarter,
    endOfYear,
    getQuarter,
    getYear,
    setYear,
    startOfMonth,
    startOfQuarter,
    startOfYear,
    subMonths,
} from 'date-fns';

import { CalendarRangePreset } from '../../../cdl/DateRangePicker/types/CalendarRangePreset';
import { RangeDirection } from '../../../cdl/DateRangePicker/types/RangeDirection';
import { translate } from '../../../common/helpers/translate.helper';

export function generateCustomerReportDatePresets(): CalendarRangePreset[] {
    const presets: CalendarRangePreset[] = [];

    const now = new Date();
    const currentYear = getYear(now);
    const currentQuarter = getQuarter(now);

    const lastYearStartDate = startOfYear(setYear(now, currentYear - 1));
    const lastYearEndDate = endOfYear(setYear(now, currentYear - 1));

    presets.push({
        label: translate('order.export.datePresets.lastYear', {
            year: (currentYear - 1).toString(),
        }),
        range: [lastYearStartDate, lastYearEndDate],
        direction: RangeDirection.Backward,
    });

    const currentYearStartDate = startOfYear(setYear(now, currentYear));
    const currentYearEndDate = endOfYear(now);

    presets.push({
        label: translate('order.export.datePresets.currentYear', {
            year: currentYear.toString(),
        }),
        range: [currentYearStartDate, currentYearEndDate],
        direction: RangeDirection.Backward,
    });

    // Generate quarters for the current year
    for (let quarter = 1; quarter <= currentQuarter; quarter++) {
        const quarterDate = new Date(currentYear, (quarter - 1) * 3, 1);
        const startDate = startOfQuarter(quarterDate);
        const endDate = endOfQuarter(quarterDate);
        presets.push({
            label: `Q${quarter} ${currentYear}`,
            range: [startDate, endDate],
            direction: RangeDirection.Backward,
        });
    }

    // Generate the last month preset
    const lastMonth = subMonths(now, 1);
    const lastMonthStartDate = startOfMonth(lastMonth);
    const lastMonthEndDate = endOfMonth(lastMonth);
    presets.push({
        label: translate('order.export.datePresets.lastMonth'),
        range: [lastMonthStartDate, lastMonthEndDate],
        direction: RangeDirection.Backward,
    });

    return presets;
}
